import React from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Cpu, LogOut } from "lucide-react";
import { useSettings } from "@/contexts/SettingsContext";
import { useFace } from "@/contexts/FaceContext";

export function TopBar({ title }) {
  const { user, logout } = useAuth();
  const { settings } = useSettings();
  const { status } = useFace();
  return (
    <div
      className="sticky top-0 z-40"
      style={{ background: "#0A0D14", borderBottom: "1px solid #1E2640" }}
      data-testid="top-bar"
    >
      <div className="h-safe-top" />
      <div className="flex items-center justify-between px-4 h-14">
        <div className="flex items-center gap-2 min-w-0">
          <div
            className="w-8 h-8 rounded-lg flex items-center justify-center font-syne font-bold"
            style={{ background: "#4F8EF7", color: "#fff" }}
          >
            {(settings?.company_name || "P").charAt(0)}
          </div>
          <div className="min-w-0">
            <div className="text-[15px] font-syne font-bold tracking-tight truncate" style={{ color: "#E8ECFF" }} data-testid="top-bar-title">
              {title || settings?.company_name || "Pulse"}
            </div>
            <div className="flex items-center gap-1 text-[10px] uppercase tracking-widest" style={{ color: "#7A85A3" }}>
              <Cpu size={10} />
              <span data-testid="ai-status">{status}</span>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          {user?.role === "admin" && (
            <span
              className="text-[10px] font-bold uppercase tracking-widest px-2 py-1 rounded-full"
              style={{ background: "rgba(155,111,235,0.15)", color: "#9B6FEB", border: "1px solid rgba(155,111,235,0.3)" }}
              data-testid="role-badge"
            >Admin</span>
          )}
          <button
            onClick={logout}
            data-testid="logout-button"
            className="w-9 h-9 rounded-lg flex items-center justify-center active:scale-95 transition-transform"
            style={{ background: "#161B2C", border: "1px solid #1E2640", color: "#7A85A3" }}
            aria-label="Logout"
          >
            <LogOut size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
